import type { UseWhyChooseUsProps, UseWhyChooseUsResult } from "@/types/types"
import { useMemo } from "react"

export const useWhyChooseUs = ({ items = [], componentId }: UseWhyChooseUsProps): UseWhyChooseUsResult => {
  // Lọc items hợp lệ
  const validItems = useMemo(() => {
    return items.filter(item => item.image && item.image.trim() && item.title && item.title.trim())
  }, [items])

  const hasValidItems = validItems.length > 0

  // Tính toán config cho Swiper
  const swiperConfig = useMemo(() => {
    const shouldLoop = validItems.length > 2

    return {
      loop: shouldLoop,
      pagination: {
        clickable: true,
      },
    }
  }, [validItems.length])

  // Tạo unique ID
  const id = useMemo(() => componentId || `why-choose-us-${Math.random().toString(36).substr(2, 9)}`, [componentId])

  return {
    validItems,
    hasValidItems,
    swiperConfig,
    id,
  }
}
